module.exports = __webpack_public_path__ + "img/cycle_logo.71d8cda2.png";